export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=90d2692e&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/lk/faq/category/question/index.vue?vue&type=template&id=90d2692e&
// module id = 1092
// module chunks = 0